export default __webpack_public_path__ + "static/media/background-retangles.7c30aa6f.png";